<ds-configuration-search-page
  [fixedFilterQuery]="fixedFilter"
  [configuration]="configuration"
  [searchEnabled]="searchEnabled"
  [sideBarWidth]="sideBarWidth"
  [showCsvExport]="true">
</ds-configuration-search-page>
